export default __webpack_public_path__ + "static/media/29.107d703d.jpeg";